.row {
  display: grid;
  grid-template-columns: minmax(8rem, 1fr) auto;
  align-items: baseline;
  gap: var(--space-s);

  padding: var(--space-2xs) 0;
}

/*
 * The scale keeps the width it had; the note button rides at the end of the
 * row, where it is out of the way of a run of picks.
 */
.rowControls {
  display: flex;
  align-items: center;
  gap: var(--space-2xs);
}

.rowControls > :first-child {
  flex: 1 1 11rem;
  min-width: 11rem;
  max-width: 18rem;
}

/*
 * The note belongs to the row above it, so it spans both columns and is inset
 * to the text column rather than starting a block of its own.
 */
.noteField {
  grid-column: 1 / -1;

  max-width: var(--measure-text);
  padding-block-start: var(--space-2xs);
}

/*
 * A row with a description grows taller than the scale beside it, so the text
 * column is aligned to the top of the row rather than to its middle.
 */
.rowText {
  display: flex;
  flex-direction: column;
  gap: var(--space-3xs);

  align-self: start;
}

.rowLabel {
  font-size: var(--size-200);

  color: var(--text);
}

.rowDescription {
  max-width: var(--measure-text);
  margin: 0;

  font-size: var(--size-200);
  line-height: var(--leading-normal);

  color: var(--text-muted);
}

/*
 * The bulk setter sits above the capabilities it fills in, so it reads as the
 * heading of the block rather than as another capability in the list.
 */
.bulkRow {
  margin-block-end: var(--space-2xs);
  padding-block-end: var(--space-xs);
  padding-right: 30px;

  font-weight: var(--weight-medium);

  border-block-end: 1px solid var(--border);
}

@media (width < 40rem) {
  .row {
    grid-template-columns: 1fr;
    gap: var(--space-2xs);
  }

  .rowControls > :first-child {
    max-width: none;
  }
}

/*
 * The guidance note is the first thing a recipient reads, so it is set apart
 * from the intro line rather than folded into it: the left rule and the raised
 * ground mark it as an explanation of the task, not as another instruction.
 */
.note {
    display: flex;
    flex-direction: column;
    gap: var(--space-2xs);
    max-width: var(--measure-text);
    margin-top: var(--space-xs);
    padding-inline: var(--space-s);
    border-left: 1px solid var(--border);
}

.noteTitle {
  margin: 0;

  font-size: var(--size-200);

  color: var(--text);
}

.noteBody {
  margin: 0;

  font-size: var(--size-200);
  line-height: var(--leading-normal);

  color: var(--text-muted);
}

/* The rail's save badge: the band pill, with the band's meaning borrowed. */
.saveBadge {
  display: inline-flex;
  align-items: center;
  align-self: flex-start;

  padding: var(--space-3xs) var(--space-xs);

  font-size: var(--size-100);
  font-weight: var(--weight-medium);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;

  color: var(--text);

  border-radius: var(--radius-pill);
}

.saveSaving {
  color: var(--text-muted);
  background-color: var(--border);
}

.saveSaved {
  background-color: var(--band-tint-solid);
}

.saveFailed {
  background-color: var(--band-tint-missing);
}

.saveFailure {
  display: flex;
  flex-direction: column;
  gap: var(--space-xs);
  align-items: flex-start;
}

.saveError {
  font-size: var(--size-100);
  line-height: var(--leading-normal);

  color: var(--text-muted);
}
